import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, styled } from "@mui/material";
import { useEffect, forwardRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
import { Wallet } from "../../app/slices/walletSlice";

export const SelectTransactionTypes = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const _TransactionTypes = useSelector(
    (state) => state.wallet.transactionType
  );
  const loading = useSelector((state) => state.wallet.wallet.loading);

  useEffect(() => {
    dispatch(Wallet.getTransactionTypes());
  }, [dispatch]);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      ref={ref}
      {...props}
      options={_TransactionTypes || []}
      getOptionLabel={(option) => {
        return option.value;
      }}
      renderInput={(params) => (
        <TextField
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          {...params}
          label="نوع العملية"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
